import {useConciergeDrawerStore} from 'presentation/components/ConciergeDrawer/store';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useGetHealthCardQuery} from '../health-card/queries/useGetHealthCardQuery';

export const useConciergeBenefits = () => {
	const {isEnabled} = useFeatureFlag(FeaturesEnum.PORTAL_FEATURE_SERVICOS_CONCIERGE);
	const {data: healthCardData, isLoading} = useGetHealthCardQuery();
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();

	const onOpenConciergeDrawer = useConciergeDrawerStore(state => state.onOpen);

	const isInfinityPlan = healthCardData?.nmPlano?.includes('INFINITY') ?? false;
	const isTRTPlan = healthCardData?.nmPlano?.includes('TRT') ?? false;
	const showConciergeButton = Boolean(
		isEnabled && (isGndiSaoPaulo || isNotredameSaude) && (isInfinityPlan || isTRTPlan),
	);

	return {
		showConciergeButton,
		onOpenConciergeDrawer,
		isLoading,
	};
};
